import React, { useEffect, useState, useRef } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { BrowserView, MobileView } from 'react-device-detect';
import { t } from 'autobiz-translate';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { formManager, Auth } from '../../config/configuration/react';
import ReportImage from './ReportImage';

const ImageGalery = (props) => {
  const { images, formId, hideLabel, refHexaId, allPictures } = props;
  const [getImage, setGetImage] = useState(false);
  const [vehImgs, setVehImgs] = useState(images);
  const [imgs, setImgs] = useState(allPictures);
  const isMounted = useRef(false);

  const getImagePath = async () => {
    const res = await allPictures.map(async (image, index) => {
      const path = await formManager.getImage(image.value[1]);
      allPictures[index].src = path;
      images.forEach((img, key) => {
        if (image.key === img.key) images[key].src = path;
      });
    });
    await Promise.all(res);
    if (isMounted.current) return;
    setGetImage(true);
    setImgs(allPictures);
    setVehImgs(images);
  };

  useEffect(() => {
    if (!getImage) getImagePath();
    return () => {
      isMounted.current = true;
    };
  }, []);

  const download = () => {
    const zip = JSZip();
    const img = zip.folder(`images_${refHexaId}`);
    imgs.forEach((i) => {
      if (!i.src) return;
      let image = i.src;
      image = image.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
      img.file(`${i.key}.jpg`, image, { base64: true });
    });
    if (Object.entries(zip.files).length - 1 === imgs.length) {
      zip.generateAsync({ type: 'blob' }).then(function saveImage(content) {
        saveAs(content, `images_${refHexaId}.zip`);
      });
    }
  };

  return (
    <>
      <MobileView>
        <div className="scroll-wrapper">
          <div className="thumbnails">
            <ul>
              {vehImgs.map((image, index) => (
                <li key={image.key}>
                  <ReportImage
                    index={index}
                    imageId={image.value[1]}
                    name={image.key}
                    formId={formId}
                    hideLabel={hideLabel}
                    allImages={vehImgs}
                  />
                </li>
              ))}
            </ul>
          </div>
          <Row className="text-right">
            <Col>
              <button type="button" className="btn btn-3" onClick={download} disabled={!getImage}>
                <span>{t('downloadPictures')}</span>
              </button>
            </Col>
          </Row>
        </div>
      </MobileView>
      <BrowserView>
        <div className="report-gallery-desktop">
          {!Auth.roleViewerAccess() && (
            <Row className="download-cta">
              <Col>
                <button type="button" className="btn btn-3" onClick={download} disabled={!getImage}>
                  <span>{t('downloadPictures')}</span>
                </button>
              </Col>
            </Row>
          )}
          <Row>
            {vehImgs.map((image, index) => (
              <Col xs="6" sm="4" md="3" xl="2" key={image.key}>
                <ReportImage
                  index={index}
                  imageId={image.value[1]}
                  name={image.key}
                  formId={formId}
                  hideLabel={hideLabel}
                  allImages={vehImgs}
                  getImage={getImage}
                />
              </Col>
            ))}
          </Row>
        </div>
      </BrowserView>
    </>
  );
};

export default ImageGalery;

ImageGalery.propTypes = {
  images: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  formId: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool.isRequired,
  refHexaId: PropTypes.string.isRequired,
  allPictures: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
};
